import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import { isMeinBuero } from '@/utils/build-env'

const isMeinbuero = isMeinBuero()

export type VarientType = 'primary' | 'primary-bright' | 'primary-light' | 'primary-blue' | 'white' | 'danger' | 'danger-light'
export const Varients = {
  PRIMARY: 'primary' as VarientType,
  PRIMARY_BRIGHT: 'primary-bright' as VarientType,
  PRIMARY_LIGHT: 'primary-light' as VarientType,
  PRIMARY_BLUE: 'primary-blue' as VarientType,
  WHITE: 'white' as VarientType,
  DANGER: 'danger' as VarientType,
  DANGER_LIGHT: 'danger-light' as VarientType,
}

interface FloatingBadgeProps {
  id?: string
  children?: ReactNode
  label?: string,
  varient?: typeof Varients[keyof typeof Varients]
  className?: string
  onClick?: () => void
  // implement position in the future
}

const useStyles = makeStyles<ThemeInterface>((theme) => ({
  badgeContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  badgeCounter: {
    fontSize: theme.fontSizes.smaller,
    height: 30,
    padding: '0 20px',
    border: theme.border,
    background: theme.white,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: -1,
  },
  [Varients.PRIMARY]: {
    border: 'none',
    background: isMeinbuero ? theme.primary : theme.navBackgroundColor,
    color: theme.white,
  },
  [Varients.PRIMARY_BRIGHT]: {
    borderColor: theme.primaryBright,
    background: theme.primaryBrightBackground,
    color: theme.black,
  },
  [Varients.PRIMARY_LIGHT]: {
    borderColor: theme.primaryLight,
    background: theme.primaryLight,
    color: theme.white,
  },
  [Varients.PRIMARY_BLUE]: {
    border: 'none',
    background: theme.navBackgroundColor,
    color: theme.white,
  },
  [Varients.DANGER]: {
    borderColor: theme.error,
    background: theme.error,
    color: theme.white,
  },
  [Varients.DANGER_LIGHT]: {
    borderColor: theme.error,
    background: theme.errorLight,
    color: theme.black,
  },
  link: {
    cursor: 'pointer',
  },
}))

export default function FloatingBadge({ label, className, children, onClick, varient = Varients.PRIMARY, id }: FloatingBadgeProps) {
  const classes = useStyles()

  return (
    <div className={classes.badgeContainer}>
      <div id={id} className={clsx(classes.badgeCounter, classes[varient], className, onClick && classes.link)} onClick={onClick}>
        {label}
        {children}
      </div>
    </div>
  )
}
